import { PropsWithChildren, useEffect } from 'react'
import { Popup as ConsolePopup } from '@integration-app/console/components/Popup'
import useParentWindow from '@integration-app/ui/hooks/useParentWindow'

import OpenInNewTabButton from './elements/OpenInNewTabButton'
import { usePopupSizes, useSetPopupSizes } from './hooks'
import { popupCvaRecipe } from './popup-recipe'

export function EmbedPopupWindow({ children }) {
  const { close, handshake } = useParentWindow()
  const sizes = usePopupSizes()
  const styles = popupCvaRecipe(sizes)

  useEffect(() => {
    // Send handshake to the parent window so that it knows we are alive.
    void handshake()
  }, [])

  function handleClose() {
    void close()
  }

  return (
    <ConsolePopup.Root
      defaultOpen
      open
      closeOnEscape={false}
      onOpenChange={({ open }) => {
        if (!open) {
          handleClose()
        }
      }}
    >
      <ConsolePopup.Window className={styles}>
        <OpenInNewTabButton />
        {children}
      </ConsolePopup.Window>
    </ConsolePopup.Root>
  )
}

export function HOCWidePopup({ children }) {
  useSetPopupSizes({ horizontal: 'wide' })

  return children
}

export function HOCChangePopupSizes({
  wide,
  children,
}: PropsWithChildren<{
  wide?: boolean
}>) {
  useSetPopupSizes({
    horizontal: wide ? 'wide' : undefined,
  })

  return <>{children}</>
}
